import React, { useState, useEffect } from "react";
import { db, auth } from "../firebase";
import { collection, query, orderBy, limit, getDocs, where, doc, getDoc } from "firebase/firestore";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";

export default function Leaderboard() {
  const [leaderboardData, setLeaderboardData] = useState([]);
  const [filter, setFilter] = useState("public"); // "public" oder "friends"
  const [timeframe, setTimeframe] = useState("alltime"); // "alltime", "24h", etc.
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchLeaderboard();
  }, [filter, timeframe]);

  const fetchLeaderboard = async () => {
    setLoading(true);
    try {
      let results = [];
      
      if (filter === "public") {
        // GLOBAL TOP 50
        const q = query(
          collection(db, "users"),
          orderBy("wins", "desc"),
          limit(50)
        );
        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => results.push({ id: doc.id, ...doc.data() }));
      } else {
        // FRIENDS ONLY
        const user = auth.currentUser;
        if (user) {
          const userDoc = await getDoc(doc(db, "users", user.uid));
          if (userDoc.exists() && userDoc.data().friends) {
            const friendUids = userDoc.data().friends.map(f => f.uid);
            // Firestore "in" Query (max 30 UIDs gleichzeitig möglich)
            if (friendUids.length > 0) {
              const q = query(
                collection(db, "users"),
                where("__name__", "in", [...friendUids, user.uid]) // Freunde + Ich
              );
              const querySnapshot = await getDocs(q);
              querySnapshot.forEach((doc) => results.push({ id: doc.id, ...doc.data() }));
              // Manuell sortieren, da "in" Query kein orderBy erlaubt
              results.sort((a, b) => (b.wins || 0) - (a.wins || 0));
            }
          }
        }
      }
      setLeaderboardData(results);
    } catch (err) {
      console.error("Leaderboard error:", err);
    }
    setLoading(false);
  };

  return (
    <div style={containerStyle}>
      <Helmet><title>Leaderboard | UN-LOCKED</title></Helmet>
      <h1 style={titleStyle}>HALL OF FAME</h1>

      <div style={filterContainer}>
        {/* Public vs Friends */}
        <div style={tabGroup}>
          <button onClick={() => setFilter("public")} style={filter === "public" ? activeTab : inactiveTab}>Public</button>
          <button onClick={() => setFilter("friends")} style={filter === "friends" ? activeTab : inactiveTab}>Friends</button>
        </div>

        {/* Zeit-Filter (Aktuell nur All-Time funktional, da wir nur 'wins' speichern) */}
        <select value={timeframe} onChange={(e) => setTimeframe(e.target.value)} style={selectStyle}>
          <option value="alltime">All-Time</option>
          <option value="24h" disabled>Last 24h (Coming soon)</option>
          <option value="7d" disabled>Last 7 Days (Coming soon)</option>
        </select>
      </div>

      <div style={tableWrapper}>
        <table style={tableStyle}>
          <thead>
            <tr style={headerRowStyle}>
              <th>Rank</th>
              <th>Player</th>
              <th>Wins 🏆</th>
              <th>Total Gold 💰</th>
            </tr>
          </thead>
          <tbody>
            {leaderboardData.map((player, index) => (
              <tr key={player.id} style={player.id === auth.currentUser?.uid ? myRowStyle : rowStyle}>
                <td>{index + 1}.</td>
                <td 
                    style={{ textAlign: "left", cursor: "pointer", textDecoration: "underline", color: "gold" }} 
                    onClick={() => navigate(`/account/${player.displayName}`)}
                    >
                    {player.avatar} {player.displayName}
                </td>
                <td>{player.wins || 0}</td>
                <td>{player.totalGold || 0}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {loading && <p>Loading Legends...</p>}
      </div>
    </div>
  );
}

// STYLES (Kurzfassung)
const containerStyle = { padding: "100px 20px", color: "white", minHeight: "100vh", textAlign: "center", backgroundImage: "url('/background.png')", backgroundSize: "cover" };
const titleStyle = { fontSize: "4em", color: "gold", textShadow: "0 0 20px rgba(255,215,0,0.5)" };
const filterContainer = { display: "flex", justifyContent: "center", gap: "20px", marginBottom: "30px", flexWrap: "wrap" };
const tabGroup = { display: "flex", border: "2px solid gold", borderRadius: "10px", overflow: "hidden" };
const activeTab = { padding: "10px 20px", backgroundColor: "gold", color: "black", border: "none", fontWeight: "bold", cursor: "pointer" };
const inactiveTab = { padding: "10px 20px", backgroundColor: "transparent", color: "white", border: "none", cursor: "pointer" };
const selectStyle = { padding: "10px", borderRadius: "10px", backgroundColor: "#222", color: "white", border: "2px solid #555" };
const tableWrapper = { maxWidth: "800px", margin: "0 auto", backgroundColor: "rgba(0,0,0,0.8)", borderRadius: "20px", padding: "20px", border: "2px solid #444" };
const tableStyle = { width: "100%", borderCollapse: "collapse" };
const headerRowStyle = { borderBottom: "2px solid gold", color: "gold" };
const rowStyle = { borderBottom: "1px solid #333", height: "50px" };
const myRowStyle = { ...rowStyle, backgroundColor: "rgba(255,215,0,0.1)", color: "gold", fontWeight: "bold" };